class Config {
    static getEnvironment() {
      return process.env.REACT_APP_ENV || 'development'
    }
  
    static getBaseUrl() {
      if (this.isProd()) {
        return 'https://www.epharma.dghealthcare.online/api/crm/'
      }
  
      if (this.isUat()) {
        return 'https://www.epharma-uat.dghealthcare.online/api/crm/'
      }
  
      if (this.isDev()) {
        return 'https://www.epharma-dev.dghealthcare.online/api/crm/'
      }
  
      return 'http://localhost:8000/api/crm/'
    }
  
    static isDev() {
      const env = this.getEnvironment()
      return env === 'dev'
    }
  
    static isUat() {
      const env = this.getEnvironment()
      return env === 'uat'
    }
  
    static isProd() {
      const env = this.getEnvironment()
      return env === 'prod'
    }

    static getBackendOrigin() {
      return this.getBaseUrl().replace(/\/api\/crm\/$/, '')
    }
  }
  
  export default Config
  